import moment from "moment";

export const dateTimeFormatter = (params) =>
  moment(params?.value).format("ddd, Do MMM YYYY, h:mm:ss a");
